import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const ModemRouter = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M10.667 11.65H10V5.985h.667v5.667Z" />
      <path d="M13 16.317H3a2.667 2.667 0 1 1 0-5.333h10a2.667 2.667 0 1 1 0 5.333ZM3 11.651a2 2 0 1 0 0 4h10a2 2 0 0 0 0-4H3Z" />
      <path d="M3 14.318a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334ZM5.667 14.318a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334ZM10.333 3.984a1.334 1.334 0 1 1 0 2.667 1.334 1.334 0 0 1 0-2.667Zm0 2a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333ZM12.456 7.91l-.472-.472.236-.235a2.665 2.665 0 0 0 0-3.771l-.236-.236.472-.471.235.235a3.333 3.333 0 0 1 0 4.714l-.235.236ZM8.212 7.91l-.236-.236a3.333 3.333 0 0 1 0-4.714l.236-.235.471.47-.235.237a2.667 2.667 0 0 0 0 3.77l.235.236-.471.472Z" />
      <path d="m13.87 9.324-.472-.471.236-.236a4.665 4.665 0 0 0 0-6.6l-.236-.235.472-.471.235.235a5.332 5.332 0 0 1 0 7.543l-.235.235ZM6.798 9.324l-.236-.235a5.333 5.333 0 0 1 0-7.543l.236-.235.471.47-.236.237a4.666 4.666 0 0 0 0 6.6l.236.235-.471.471Z" />
    </svg>
  );
};

ModemRouter.category = 'product-category';

ModemRouter.displayName = 'ModemRouter';
